<template>
    <PlacementMultiplier
        :promotionFactor="promotionFactorComputed"
        :currencyName="currencyNameComputed"
        :reward="rewardComputed"
        @changeMultiplierFactor="changeMultiplierFactor"
    />
</template>

<script>
import eventBus from '../mixins/eventBus';
import externalParsedProps from '../mixins/externalParsedProps';
import externalPropsParser from 'services/utils/externalPropsParser';
import PlacementMultiplier from '../pages/monetize/adUnitSettings/PlacementMultiplier.vue';

const parsedProps = ['promotionFactor', 'currencyName', 'reward'];

export default {
    name: 'PlacementMultiplierEx',
    components: { PlacementMultiplier },
    mixins: [
        eventBus('placement-multiplier-ex'),
        externalParsedProps(PlacementMultiplier.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(PlacementMultiplier.props, parsedProps),
    methods: {
        changeMultiplierFactor(data) {
            this.$emit('changeMultiplierFactor', data);
        }
    }
};
</script>

<style scoped>

</style>
